import { Menu } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import type React from 'react';
import { PresenceIndicators } from './PresenceIndicators';

const bannerHeight = 50;
const buttonBoxSize = bannerHeight;

/**
 * {@link Banner} input props
 */
interface Props {
	/**
	 * Function to invoke to open the datapad menu
	 */
	onOpenMenu?: () => void;
}

/**
 * Datapad banner - top-level toolbar.
 */
export function Banner(props: Props): React.ReactElement {
	const { onOpenMenu } = props;

	return (
		<Box
			component="header"
			sx={{
				position: 'relative',
				bgcolor: 'grey.900',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
				height: bannerHeight,
			}}
		>
			<Box
				sx={{
					width: buttonBoxSize,
				}}
			>
				{onOpenMenu !== undefined && (
					<Tooltip title="Expand menu">
						<IconButton onClick={onOpenMenu} sx={{ ml: 0.5 }}>
							<Menu />
						</IconButton>
					</Tooltip>
				)}
			</Box>
			<PresenceIndicators />
			{/* Empty box at the end to ensure centering of presence indicators above */}
			<Box
				sx={{
					width: buttonBoxSize,
				}}
			></Box>
		</Box>
	);
}
